module.exports = __webpack_public_path__ + "static/media/sprint-logo-white.65ba8809.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/sprint-logo-white.svg
// module id = 1323
// module chunks = 0